import React, { useEffect } from 'react'
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom';
import bg1 from '../../../../assets/images/home/bgred.svg'
import shape1 from '../../../../assets/images/shapes/shape1.svg'
import shape2 from '../../../../assets/images/shapes/arrow-multiple.png'
import Footer from '../Home/HomeComponents/Footer';
import { useSelector } from 'react-redux';


const About = () => {
    const navigate = useNavigate()
    const { about } = useSelector(state => state.configSlice);
    
    useEffect(() => {
        const body = document.body;
        body.classList.remove("filter-active");
      }, []);

    return (
        <>
            {
                about.length > 0 && about.map(element => {
                    switch (element.type) {
                        case "A":
                            return (
                                <section className="banner aboutbanner position-relative" key={element.id}>
                                    <img src={shape1} className='shape1' alt="" />
                                    <img src={shape2} style={{ position: 'absolute', top: '8%', left: '5%', width: '100px' }} alt="" />
                                    <div className="container position-relative z-1">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <h2 dangerouslySetInnerHTML={{ __html: element.heading }} />
                                                <p>{element.paragraph}</p>
                                                <button onClick={() => navigate('/contact')} className='btn btn-danger'>Contact us</button>
                                            </div>
                                            <div className="col-md-6">
                                                <img src={element.image} className='img-fluid rounded-2' alt="SkillVirtual platform is a skilling solution" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            );
                        case "B":
                            return (
                                <section className='arvrtertgh' key={element.type}>
                                    <div className="container">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <img src={element.image} className='img-fluid' alt="" />
                                            </div>
                                            <div className="col-md-6">
                                                <h2 className='text-danger'>{element.heading}</h2>
                                                <ul className='lisxfdf'>
                                                    {element.sections.map((point, index) => <li key={index}><CheckIcon /> <span>{point}</span></li>)}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            );
                        case "C":
                            return (
                                <section className="platforms">
                                    <img src={bg1} className='img-fluid bg1' alt="" />
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="pltbox">
                                                    <img src={element.image} style={{ bottom: '105px' }} className='linefr' alt="" />
                                                    <div className="row justify-content-center align-items-center">
                                                        <div className="col-md-10 text-center">
                                                            <h3 className='text-danger'>{element.heading}</h3>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        {element.sections.map((element) =>
                                                            <div className="col-md-4 mt-5">
                                                                <div className="pltboxcont">
                                                                    <div className="thumbng">
                                                                        <img src={element.image} alt="" />
                                                                    </div>
                                                                <span dangerouslySetInnerHTML={{ __html: element.label }} />   
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            );
                        case "D":
                            return (
                                <section className="keycontoff">
                                    <div className="container">
                                        <h2 className='text-center text-danger mb-4'>{element.heading}</h2>
                                        <div className="row mt-2">
                                            <div className="col-md-6">
                                                <div className="card h-100 border-0">
                                                    <div className="card-body rounded-2 crm-bg-yellow-light pt-4">
                                                        <h4>{element.sections[0].label}</h4>
                                                        <p style={{ maxWidth: '85%' }}>{element.sections[0].description}</p>
                                                        <img src={element.sections[0].image} style={{ height: '250px' }} alt="Self learning applications" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card border-0 mb-4">
                                                    <div className="card-body rounded-2 crm-bg-yellow-light">
                                                        <div className='position-relative z-1 py-3'>
                                                            <h4>{element.sections[1].label}</h4>
                                                            <p style={{ maxWidth: '75%' }}>{element.sections[1].description}</p>
                                                        </div>
                                                        <img style={{ height: '150px' }} src={element.sections[1].image} className='trana' alt="Multiple training modes" />
                                                    </div>
                                                </div>
                                                <div className="card border-0">
                                                    <div className="card-body rounded-2 crm-bg-yellow-light">
                                                        <div className='position-relative z-1 py-3'>
                                                            <h4>{element.sections[2].label}</h4>
                                                            <p style={{ maxWidth: '65%' }}>{element.sections[2].description}</p>
                                                        </div>
                                                        <img src={element.sections[2].image} className='trana' alt="Training analytics" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            );
                        default:
                            return null;
                    }
                })
            }

            <Footer afooter="afooter" />

        </>
    )
}

export default About
